import { render, staticRenderFns } from "./matrice-gain-modal.vue?vue&type=template&id=10256508&scoped=true"
import script from "./matrice-gain-modal.vue?vue&type=script&lang=js"
export * from "./matrice-gain-modal.vue?vue&type=script&lang=js"
import style0 from "./matrice-gain-modal.vue?vue&type=style&index=0&id=10256508&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10256508",
  null
  
)

export default component.exports